import { render, staticRenderFns } from "./AgentFormDialog.vue?vue&type=template&id=789351c6&"
import script from "./AgentFormDialog.vue?vue&type=script&lang=ts&"
export * from "./AgentFormDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports